import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken, getDateRange} from '../../storage'
import {DRN} from './daterange'


export default class Purchases extends React.Component {
  constructor() {
    super();
    let dateRange = getDateRange()
    this.state = {
      tableState: {},
      apiurl : "/list_supplier_purchases/?",
      data: [],
      pages: null,
      loading: true,
      dateRange : dateRange
    };
    this.fetchData = this.fetchData.bind(this);
    this.applyDateRange = this.applyDateRange.bind(this)
    document.title = "supplier Purchases"
  }


  fetchData(state, instance, dateRange=this.state.dateRange) {
    this.setState({ loading: true });
    let apiurl = this.state.apiurl + '&page=' + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }

    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    this.setState({tableState:state})

    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.supplier_purchases,
        pages: res.data.pages,
        loading: false
      });
    }).catch((err)=>{
      this.setState({loading:false})
    })
  }

  applyDateRange(dateRange){
    this.fetchData(this.state.tableState, {}, dateRange)
  }

  render() {

    const { data, pages, loading } = this.state;
    const columns = [
      {Header:'Supplier', accessor: 'suppliername',sortable:true },
      {Header:'Items', accessor: 'purchases', sortable:true, className:'text-right'},
      {Header:'Business', accessor:'business', sortable:true, className:'text-right'}
    ]

    return <div >
    <section className="medium">
      <div className="row">
        <div className="col-sm-5">
          <h3>Suppliers Purchase Report</h3>
        </div>
        <div className="col-sm-3 col-sm-offset-4">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
        </div>
      </div>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="table-responsive">
          <ReactTable
            noDataText="No Records Found."
              columns={columns} manual data={data}
              pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
        </div>

      </div>
    </div>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/report/supplierpurchasessummary.js